// src/utils/api.js
const API_URL = process.env.REACT_APP_API_URL;

export const apiFetch = async (path, options = {}) => {
  // 🔐 Pull user from storage every request (source of truth)
  const storedUser =
    JSON.parse(localStorage.getItem("user")) ||
    JSON.parse(sessionStorage.getItem("user"));

  const token = storedUser?.token;

  const isFormData = options.body instanceof FormData;

  return fetch(`${API_URL}${path}`, {
    ...options,
    headers: {
      ...(options.headers || {}),
      ...(isFormData ? {} : { "Content-Type": "application/json" }),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });
};

if (process.env.NODE_ENV === "development") {
  window.apiFetch = apiFetch;
}
